export const pxToEm = (px: number, baseFontSize = 16) => {
  return `${px / baseFontSize}em`;
};
